export default "__VITE_ASSET__CC1Dyt4r__"